export function matchSocialNetworkUrl (url: string) {
  if (url) {
    const regExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
    if (url.match(regExp)) {
      return true
    }
  }
  return false
}

export function getYTId (url: string) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = url.match(regExp)

  return (match && match[2].length === 11)
    ? match[2]
    : ''
}

export function getFBId (url: string) {
  const regExp = /^.*(?:https?:\/\/)?(?:www\.)?facebook\.com\/.(?:(?:\w)*#!\/)?(?:pages\/)?(?:[\w-]*\/)*([\w\-.]*).*/
  const match = url.match(regExp)
  const id = match && match[1].split('_')
  return id && id[1]
}
